import { observer } from "mobx-react-lite";
import { useState } from "react";

const PositionCardSubExpense = ({ index, name, value }) => {
    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <li>
            <div className="leftSide">
                <div className="num">{index+1}.</div>
                <div className="name">
                    <div className="title">{name}</div>
                    {/* <ul>
                        <li>Аренда</li>
                        <li>Офис</li>
                    </ul> */}
                </div>
            </div>
            <div className="rightSide">
                <div className="text">Сумма</div>
                <div className="value">{formatNumber(value)} ₽</div>
            </div>
        </li>
    );
}

export default observer(PositionCardSubExpense);